import React, { useEffect, useRef, useState } from 'react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { Button, Box } from 'rebass';
import store from 'store';
import helpers from 'utils/helpers';
import moment from 'moment-timezone';

export default ({ maxWidth = '800px', minWidth = '600px', ...props }) => {
    const store_iE_key = 'SideOverlay_isExpanded';
    const store_isExpanded = props.isExpanded == 1 ? 1 : store.get(store_iE_key);

    const [isExpanded, setIsExpanded] = useState(store_isExpanded);
    const panelRef = useRef(null);

    const svgStyle = { fontSize: '22px' };

    useEffect(() => {
        const handleMouseDown = e => {
            // Close only when clicking outside the panel AND outside any portal-rendered
            // elements (e.g. Combobox dropdown, DatePicker popover). Portal children are
            // appended as direct children of document.body, so we check whether the click
            // target lives inside the #app root — if it does, it's regular page content
            // (i.e. a true "outside" click). Clicks on portal content are ignored.
            if (panelRef.current && !panelRef.current.contains(e.target)) {
                const appRoot = document.getElementById('app');
                if (appRoot && appRoot.contains(e.target)) {
                    props.onClose();
                }
            }
        };

        document.addEventListener('mousedown', handleMouseDown);
        return () => document.removeEventListener('mousedown', handleMouseDown);
    }, [props.onClose]);

    return (
        <div
            ref={panelRef}
            style={{
                position: 'fixed',
                right: 0,
                top: 0,
                bottom: 0,
                zIndex: 999,
                textAlign: 'left',
                width: isExpanded ? maxWidth : minWidth,
                borderLeft: '1px solid #eee',
                background: '#fefefe',
                boxShadow: 'rgba(36, 18, 77, 0.1) -10px -8px 12px -6px',
                overflow: 'scroll'
            }}
            {...props}
        >
            {props.children}

            <Box style={{ position: 'absolute', top: '15px', zIndex: 10, left: '8px' }} fontSize={1}>
                <Button
                    variant="link"
                    className="muted"
                    onClick={() => {
                        const newVal = !isExpanded;
                        setIsExpanded(newVal);
                        store.set(store_iE_key, newVal);
                    }}
                >
                    {helpers.newFeatureTag(moment('12-08-2021', 'MM-DD-YYYY'), { margin: '0 8px 0 0' })}
                    {isExpanded ? (
                        <>
                            <FiChevronRight style={svgStyle} />
                        </>
                    ) : (
                        <>
                            <FiChevronLeft style={svgStyle} />
                        </>
                    )}
                </Button>
            </Box>
        </div>
    );
};
